var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadedFilled = function SvgUploadedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#145CC5",
    clipPath: "url(#uploadedFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.473 7.506a3.416 3.416 0 0 0-3.413 3.413 3.41 3.41 0 0 0 3.413 3.413 3.41 3.41 0 0 0 3.414-3.413 3.41 3.41 0 0 0-3.414-3.413m1.754 3.127-1.72 1.72c-.1.1-.227.146-.354.146a.5.5 0 0 1-.353-.147l-.953-.953a.503.503 0 0 1 0-.706.503.503 0 0 1 .706 0l.6.6 1.367-1.367a.503.503 0 0 1 .707 0 .503.503 0 0 1 0 .707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.44 4.28 9.587 2.393A1.3 1.3 0 0 0 8.647 2h-4.1C3.14 2 2 3.16 2 4.593v6.814C2 12.84 3.14 14 4.547 14H7.34a4.4 4.4 0 0 1 4.48-7.273V5.2c0-.347-.133-.673-.373-.92zM6.133 9.293H4.327a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h2.326c-.213.307-.38.647-.513 1zm1.68-2.18H4.32a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5h4.067c.26 0 .46.2.486.447-.38.14-.74.327-1.066.553zm3.16-1.806h-2.12a.37.37 0 0 1-.366-.367V2.727c0-.047.06-.074.093-.04l2.44 2.506c.04.04.013.107-.047.107z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uploadedFilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUploadedFilled;